import PaymentMode from '@/assets/enums/invoicing/PaymentMode.js'

/**
 * The cheque already carrying a number, as the API describes it both in the
 * availability check and in the 422 refusing a duplicate.
 */
export type ChequeDuplicate = {
  payment_id: string
  check_number: string
  emission_date: string
  invoice_id: string | null
  invoice_reference: string | null
}

/** `blocked_code` of the 422 sent when a cheque number is already used. */
export const CHEQUE_NUMBER_ALREADY_USED = 'cheque_number_already_used'

const CHEQUE_MODES: string[] = [PaymentMode.CHECK, PaymentMode.CAUTION_CHECK]

/**
 * Whether the payment mode identifies a physical cheque by its number: the
 * only modes the API refuses a duplicate number for.
 */
export function isChequeMode(paymentMode: string | null | undefined): boolean {
  return CHEQUE_MODES.includes(paymentMode ?? '')
}

/**
 * The duplicate carried by a failed payment submission, or null when the
 * failure is anything else.
 */
export function duplicateFromError(error: unknown): ChequeDuplicate | null {
  const data = (error as { response?: { data?: any } })?.response?.data

  return data?.blocked_code === CHEQUE_NUMBER_ALREADY_USED
    ? (data.duplicate ?? null)
    : null
}
